import { connect } from 'react-redux'
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { closeModalRenewalFranchise } from '../../../actions/purchaseActions'
import { formatURL } from '../../../utils';

export class ModalTravelRenewalFranchise extends Component {
    constructor(props) {
        super(props)
        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        const location = {
            pathname: formatURL(
                this.props.match,
                `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
                window.location.search
            ),
        }
        this.props.closeModalRenewalFranchise();
        this.props.history.replace(location);
    }

    render() {
        if (!this.props.isModalRenewalFranchiseActive)
            return <div />

        const benefits = this.props.rawProductCoverage

        let franchise = benefits.filter(
            benefit => benefit.code === '500'
        )

        franchise = franchise.length && franchise[0]

        return (
            <div className="comp_modalpagamento quotationDateWarning-modal franchise-modal" onClick={this.props.closeModalRenewalFranchise}>
                <div className="modalcontents" onClick={ e => e.stopPropagation()}>
                    <div onClick={this.props.closeModalRenewalFranchise} className="close-btn"> &times; </div>
                    <div className="contents">
                        <div className="modalmiddle">
                            <h3>Atenção! Este plano possui franquia e é {!this.props.mobile && <br />} específico para quem já está em viagem!</h3>

                            <p className="text-middle">
                            O seguro viagem escolhido é uma excelente opção para quem já está viajando, mas atenção, para acionar Despesas Médicas Hospitalares (DMH) existe uma franquia de {franchise.coverage}.
                            </p>
                        </div>
                        <div className="choosecontainer">
                            <div className="optionone">
                                <button className="button" onClick={this.goToSearchPage}>
                                    <span>Voltar à pesquisa</span>
                                </button>
                            </div>
                        </div>
                        <div className="choosecontainer continue">
                            <div className="optionone">
                                <button className="button" onClick={this.props.closeModalRenewalFranchise}>
                                    <span>Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        benefits: state.purchase.benefits_list,
        rawProductCoverage: state.coverage.rawProductCoverage,
        isModalRenewalFranchiseActive: state.purchase.isModalRenewalFranchiseActive,
        mobile: state.mobile.mobileActive,
    }),
    {
        closeModalRenewalFranchise
    }
)(withRouter(ModalTravelRenewalFranchise));



// WEBPACK FOOTER //
// ./src/components/purchase/modal_travel_renewal_franchise/ModalTravelRenewalFranchise.jsx